import {
  Calculator,
  Building2,
  UserCircle,
  PieChartIcon as ChartPieIcon,
  Receipt,
  FileText,
} from "lucide-react";
import Model1 from "../../../Static/Models/model1.svg";
import Model2 from "../../../Static/Models/model2.svg";

export default function TaxServices() {
  const categories = [
    {
      icon: <Calculator className="w-6 h-6" />,
      title: "GST",
      description:
        "Comprehensive GST services including filing, compliance, and audit assistance.",
      jobs: "5 services",
    },
    {
      icon: <ChartPieIcon className="w-6 h-6" />,
      title: "TDS/TCS",
      description:
        "Manage TDS/TCS filings, reconciliation, and compliance for accurate tax handling.",
      jobs: "3 services",
    },
    {
      icon: <Building2 className="w-6 h-6" />,
      title: "Income Tax",
      description:
        "Expert assistance with filing individual and corporate tax returns, and strategic tax planning.",
      jobs: "5 services",
    },
    {
      icon: <Receipt className="w-6 h-6" />,
      title: "Other Services",
      description:
        "Avail consultation, financial planning, and compliance support tailored to your needs.",
      jobs: "3 services",
    },
  ];

  return (
    <section className="py-12 px-5 md:py-24">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center">
          <h2 className="sm:text-3xl text-xl font-bold">
            Professional
            <span className="text-[#151C62] border-b-2 border-[#151C62] pb-1">
              {" "}
              Tax Services
            </span>
          </h2>
        </div>
        {/* Top Cards */}
        <div className="grid md:grid-cols-2 gap-6 mb-16 mt-10">
          <div className="bg-primary/5 border-none p-6 rounded-xl shadow-lg flex items-center gap-6">
            <div className="flex-1 space-y-2">
              <h3 className="text-2xl font-semibold">For Businesses</h3>
              <p className="text-muted-foreground !mb-2">
                Comprehensive tax solutions for companies of all sizes. Expert
                guidance for your business needs.
              </p>
              <a href="#contact">
                <button className="bg-[#151C62] text-white  py-2 px-6 rounded-md hover:bg-primary/80 transition">
                  Schedule Consultation
                </button>
              </a>
            </div>
            <div className="hidden md:block w-32 h-32 bg-secondary/10 rounded-full">
              <img src={Model2} alt="Model1" height={200} width={200} />
            </div>
          </div>

          <div className="bg-secondary/5 border-none p-6 rounded-xl shadow-lg flex items-center gap-6">
            <div className="flex-1 space-y-2">
              <h3 className="text-2xl font-semibold">For Individuals</h3>
              <p className="text-muted-foreground  !mb-2">
                Professional tax services tailored to your personal financial
                goals.
              </p>
              <a href="#contact">
                <button className="bg-[#151C62] text-white py-2 px-6 rounded-md hover:bg-secondary/80 transition">
                  Get Started
                </button>
              </a>
            </div>
            <div className="hidden md:block w-32 h-32 bg-secondary/10 rounded-full">
              <img src={Model1} alt="Model1" height={200} width={200} />
            </div>
          </div>
        </div>

        {/* Categories Section */}
        <div className="space-y-6 px-4">
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-semibold">
              Popular
              <span className="text-[#151C62]"> Services</span>
            </h2>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {categories.map((category, index) => (
              <div
                key={index}
                className="group hover:shadow-lg transition-all bg-white rounded-lg p-6 shadow-md"
              >
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-2 group-hover:bg-primary/20 transition-colors">
                  {category.icon}
                </div>
                <h4 className="text-lg font-semibold text-[#151C62]">
                  {category.title}
                </h4>
                <p className="text-sm text-muted-foreground">
                  {category.description}
                </p>
                <p className="text-sm text-muted-foreground mt-2">
                  {category.jobs}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
